import { UserRole } from '../types/user.js';
/**
 * Roles that bind a user to a single organization (school or institution).
 * Per Decision #1, a user may not hold both simultaneously — they imply
 * belonging to two different orgs.
 */
export const CROSS_ORG_ROLES = [UserRole.SCHOOL, UserRole.INSTITUTION];
/**
 * Validate a role combination against Decision #1 constraints.
 *
 * Decision #1 scope for this iteration: JUDGE/COACH/VOLUNTEER may combine
 * freely with ADMIN/SUPER_ADMIN/COMPETITION_MANAGER (and with each other).
 * The minimal forbidden combinations are:
 *   - CONTESTANT cannot combine with any other role (contestant is exclusive).
 *   - SCHOOL + INSTITUTION cannot coexist (cross-organization).
 *
 * @returns an i18n error key (e.g. `roleCombo.contestantExclusive`) when the
 *          combination is forbidden, or `null` when it is allowed.
 */
export function validateRoleCombination(roles) {
    // De-duplicate defensively; treat the unique set as the combination.
    const unique = Array.from(new Set(roles));
    // Single role (or empty) is always allowed.
    if (unique.length <= 1)
        return null;
    // Contestant is an exclusive role — it cannot be combined with anything.
    if (unique.includes(UserRole.CONTESTANT)) {
        return 'roleCombo.contestantExclusive';
    }
    // SCHOOL and INSTITUTION bind to different organizations; holding both
    // would be ambiguous, so forbid the combination.
    const crossOrg = unique.filter((r) => CROSS_ORG_ROLES.includes(r));
    if (crossOrg.length >= 2) {
        return 'roleCombo.noCrossOrg';
    }
    return null;
}
//# sourceMappingURL=role-combo.js.map